import React from 'react'
import PropTypes from 'prop-types'

const Row = ({ label, value, bold = false, className = '' }) => (
  <div
    className={`flex justify-between items-center py-1 ${bold ? 'font-semibold text-base' : 'text-sm text-gray-600'} ${className}`}
  >
    <span>{label}</span>
    <span>₹{Number(value).toLocaleString('en-IN')}</span>
  </div>
)

Row.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  bold: PropTypes.bool,
  className: PropTypes.string,
}

const PriceBreakup = ({ breakup, className = '' }) => {
  if (!breakup) return null

  const { tour, services = [], discount, subtotal, total } = breakup

  return (
    <div className={`space-y-2 ${className}`}>
      {/* Tour base */}
      {tour && (
        <>
          <p className="text-xs text-gray-500 uppercase tracking-wide font-medium">Tour</p>
          <Row label={`Adults × ${tour.adults}`} value={tour.adult_total} />
          {tour.children > 0 && (
            <Row label={`Children × ${tour.children} (50% off)`} value={tour.child_total} />
          )}
        </>
      )}

      {/* Services */}
      {services.length > 0 && (
        <>
          <hr className="border-gray-200 my-1" />
          <p className="text-xs text-gray-500 uppercase tracking-wide font-medium">Services</p>
          {services.map((s) => {
            const qty = s.quantity > 1 ? ' × ' + s.quantity : ''
            return <Row key={s.name + s.cost} label={s.name + qty} value={s.cost} />
          })}
        </>
      )}

      {/* Subtotal */}
      <hr className="border-gray-200 my-1" />
      <Row label="Subtotal" value={subtotal} bold />

      {/* Discount */}
      {discount && discount.amount > 0 && (
        <div className="flex justify-between items-center py-1 text-sm text-green-600">
          <span>
            Discount{discount.code ? ` (${discount.code})` : ''}
            {discount.type === 'percentage' ? ` — ${discount.value}%` : ''}
          </span>
          <span>−₹{Number(discount.amount).toLocaleString('en-IN')}</span>
        </div>
      )}

      {/* Total */}
      <hr className="border-gray-300 my-1" />
      <Row label="Total" value={total} bold className="text-lg" />
    </div>
  )
}

PriceBreakup.propTypes = {
  breakup: PropTypes.shape({
    tour: PropTypes.shape({
      name: PropTypes.string,
      base_price: PropTypes.number,
      adults: PropTypes.number,
      children: PropTypes.number,
      adult_total: PropTypes.number,
      child_total: PropTypes.number,
    }),
    services: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        cost: PropTypes.number,
        quantity: PropTypes.number,
      }),
    ),
    subtotal: PropTypes.number,
    total: PropTypes.number,
    discount: PropTypes.shape({
      code: PropTypes.string,
      type: PropTypes.string,
      value: PropTypes.number,
      amount: PropTypes.number,
    }),
  }),
  className: PropTypes.string,
}

export default PriceBreakup
